import _throttle from "lodash.throttle";
import eventBus from '../utils/eventBus';

const infoImageHeight = () => {

  const infoImages = document.querySelectorAll('.wp-quiz-slider--info-image');

  infoImages.forEach(slider => {

    const wrapper = slider.closest('.wp-quiz-item');
    wrapper.classList.add('wp-quiz-item--is-pristine');

    const img = slider.querySelector('.wp-quiz-item__image-img');
    const sliderWrapper = slider.closest('.wp-quiz-item__image');

    sliderWrapper.style.setProperty('--slider-aspect-ratio', img.offsetHeight + 'px');

    eventBus.on('wp-quiz-step-changed', (ev) => {
      sliderWrapper.style.setProperty('--slider-aspect-ratio', img.offsetHeight + 'px');
    })

  });

}

window.addEventListener('DOMContentLoaded', infoImageHeight, { once: true });
window.addEventListener('resize', _throttle(infoImageHeight, 500))

const infoImageButtons = () => {

  eventBus.on('wp-quiz-slider-slide-changed', (ev) => {
    const wrapper = ev.detail.elm.closest('.wp-quiz-item');
    if(ev.detail.slider.isEnd) {
      wrapper.classList.remove('wp-quiz-item--is-pristine');
      wrapper.classList.add('wp-quiz-item--is-right');
    } else {
      wrapper.classList.add('wp-quiz-item--is-pristine');
      wrapper.classList.remove('wp-quiz-item--is-right');
    }
  });


}
window.addEventListener('DOMContentLoaded', infoImageButtons, { once: true });

